<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-text-field
            class="mt-5"
            label="Title"
            v-model.trim="doc.title"
            :rules="titleRules"
            type="text"
            placeholder="Title"
            id="title"
            required
          ></v-text-field>

          <v-textarea
            label="Description"
            v-model.trim="doc.description"
            type="text"
            placeholder="Description"
            id="description"
            rows="2"
          ></v-textarea>

          <v-select
            :items="categories"
            label="Type"
            v-model.trim="doc.categories"
            :rules="categoryRules"
            required
          ></v-select>

          <v-select
            :items="cols"
            label="Column"
            v-model.trim="doc.model"
            item-text="title"
            item-value="model"
          ></v-select>

          <unit-sub-items v-model="doc.subitems" name="sub">
            <v-label
              ><span class="black--text"
                >What are the steps for this action?</span
              ></v-label
            >
            <p class="ma-0">Type below and press <strong>Add</strong></p>
          </unit-sub-items>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { UnitSubItems } from "@/components/units";

export default {
  name: "UserServiceForm",
  data() {
    return {
      categories: [
        "Digital",
        "Physical",
        "Logistics",
        "Bottleneck",
        "Opportunity",
      ],
      // cols: [
      //   {
      //     title: "Awareness",
      //     model: "list1",
      //   },
      //   {
      //     title: "First contact",
      //     model: "list2",
      //   },
      //   {
      //     title: "Engagement",
      //     model: "list3",
      //   },
      //   {
      //     title: "Return",
      //     model: "list4",
      //   },
      //   {
      //     title: "Leave",
      //     model: "list5",
      //   },
      //   {
      //     title: "Inbox",
      //     model: "all",
      //   },
      // ],
      cols: [
        {
          title: "Planning",
          model: "list1",
        },
        {
          title: "Arrival",
          model: "list2",
        },
        {
          title: "Orientation",
          model: "list3",
        },
        {
          title: "Get",
          model: "list4",
        },
        {
          title: "Leave",
          model: "list5",
        },
        {
          title: "Inbox",
          model: "all",
        },
      ],
      items: [],
      titleRules: [(v) => !!v || "Title is required"],
      categoryRules: [(v) => !!v || "Category is required"],
      search: null,
    };
  },
  props: {
    doc: Object,
  },
  components: {
    UnitSubItems,
  },
  methods: {
    addItem($event) {
      this.subitems.push({ title: $event.title });
    },
    // addToTags() {
    //   let ref = fb.serviceTagsCollection.doc();
    //   ref.set({
    //     createdOn: new Date(),
    //     id: ref.id,
    //     title: this.populateField(this.doc.title),
    //   }).then(() => {
    //     this.$emit('complete')
    //   })
    //   .catch((error) => {
    //     alert("Error adding document: ", error);
    //   });

    // }
  },
};
</script>
